<template>
  <div class="px-8 bg-white navbar-container">
    <pt-modal
      ref="acceptOrderModal"
      :close-on-outside-click="false"
      size="medium"
    >
      <div slot="modal-header">Confirmation</div>
      <div slot="modal-body">
        <p>{{ dialogue }}</p>
      </div>
      <div slot="modal-footer">
        <pt-button
          :disabled="accepting"
          variant="primary"
          class="mb-2 md:mb-0 mr-2 w-full md:w-1/4"
          @action="submit"
        >
          <i v-if="accepting" class="fa fa-refresh fa-spin" />
          {{ accepting ? 'Please wait...' : 'Yes' }}
        </pt-button>
        <pt-button
          :disabled="accepting"
          variant="secondary"
          class="w-full md:w-1/4"
          @action="cancel"
        >
          No
        </pt-button>
      </div>
    </pt-modal>
    <div class="flex flex-wrap">
      <div class="w-full lg:w-3/4 hidden lg:block">
        <nav-items />
      </div>
      <div v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_ORDERS)" class="w-full lg:w-1/4">
        <div class="flex justify-between lg:justify-end py-3">
          <div class="accepting-text self-center mr-4">
            Accepting Orders
          </div>
          <div class="accept-toggle">
            <pt-form-group>
              <pt-form-switch
                ref="acceptSwitch"
                v-model="isAcceptingOrder"
                on-label="Yes"
                off-label="No"
                @input="changeStatus"
              />
            </pt-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PtFormGroup, PtFormSwitch } from '@pathao/ui-components/esm/FormComponents';
import config from '@src/config';
import NavItems from './NavItems';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { ACCEPT_ORDER } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import { mapGetters, mapActions } from 'vuex';
import LS from '@utils/local-storage';

export default {
  components: {
    PtFormGroup,
    PtFormSwitch,
    NavItems,
    PtModal,
  },
  data() {
    return {
      accepting: false,
      dialogue: '',
      isAcceptingOrder: false,
      USER_PERMISSIONS: config.PERMISSIONS,
    };
  },
  computed: {
    ...mapGetters({
      permissions: 'auth/permissions',
      userName: 'auth/userName',
    }),
  },
  created() {
    if (this.permissions.includes('can_accept_order')) {
      const orderAcceptingStatus = LS.get('order-accepting-status');
      if (orderAcceptingStatus === null) {
        this.checkRestoStatus()
          .then((result) => {
            this.isAcceptingOrder = result.data.accepting_order;
          });
      } else {
        this.isAcceptingOrder = orderAcceptingStatus;
      }
    }
  },
  methods: {
    changeStatus() {
      this.$refs.acceptOrderModal.showModal();
      if (this.isAcceptingOrder) {
        this.dialogue = 'Are you sure you want to accept orders?';
      } else {
        this.dialogue = 'Are you sure you don\'t want to accept any orders?';
      }
    },
    cancel() {
      this.isAcceptingOrder = !this.isAcceptingOrder;
      this.$refs.acceptOrderModal.closeModal();
    },
    submit() {
      let payload = {
        url: ACCEPT_ORDER,
        method: 'POST',
        data: {
          accepting_order: this.isAcceptingOrder,
        },
      };
      this.accepting = true;
      apiRequest(payload)
        .then((response) => {
          this.accepting = false;
          this.updateOrderAcceptingStatus(this.isAcceptingOrder);
          this.$refs.acceptOrderModal.closeModal();

          this.$sendEvent('RS_AcceptingOrders', { accepting_order_status: this.isAcceptingOrder });
        })
        .catch(() => {
          this.accepting = false;
          this.isAcceptingOrder = !this.isAcceptingOrder;
        });
    },
    matchesUserPermission(routePermission) {
      const userPermissions = this.permissions; // this.$store.getters['auth/permissions'];

      let hasPermission = false;

      hasPermission = userPermissions.includes(routePermission);

      return hasPermission;
    },
    ...mapActions({
      checkRestoStatus: 'app/checkRestoStatus',
      updateOrderAcceptingStatus: 'app/updateOrderAcceptingStatus',
    }),
  },
};
</script>

<style>
.m-w-110 {
  min-width: 110px;
}
.navbar-container {
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12);
}
.navigation-hr li {
  font-size: 14px;
  color: #545454;
}
.accepting-text {
  font-size: 14px;
  color: #000000;
  text-align: right;
  line-height: 20px;
}
.navigation-hr li.router-link-active {
  color: #E83330;
  border-bottom: 3px solid #E83330;
}
@media screen and (max-width: 992px) {
  .navigation-hr li.router-link-active {
    color: #E83330;
    border-right: 3px solid #E83330;
    border-bottom: none;
  }
}
.pt-form-group-container .pt-form-group-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
}

.accept-toggle .pt-form-group-body {
  margin-top: 0 !important;
}
</style>
